<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <edit-icon
      size="1.3x"
      class="hover:text-primary cursor-pointer"
    />
    <trash-2-icon
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
    />
    <play-icon 
      size="1.3x" 
      class="ml-3 hover:text-primary cursor-pointer"
    >
    </play-icon>
    <stop-circle-icon
      size="1.3x" 
      class="ml-3 hover:text-primary cursor-pointer"
    >
    </stop-circle-icon>
    <refresh-cw-icon 
      size="1.3x" 
      class="ml-3 hover:text-primary cursor-pointer"
    >
    </refresh-cw-icon>
    <home-icon 
      size="1.3x" 
      class="ml-3 hover:text-primary cursor-pointer"
    >
    </home-icon>
  </div>
</template>

<script>
import { EditIcon, Trash2Icon,PlayIcon,StopCircleIcon,RefreshCwIcon,HomeIcon   } from 'vue-feather-icons'

export default {
  name: 'CellRendererActions',
  components: {
    EditIcon,
    Trash2Icon,
    PlayIcon,
    StopCircleIcon,
    RefreshCwIcon,
    HomeIcon
  },
//   methods: {
//     ConfirmDelete () {
//       this.$vs.dialog({
//         type: 'confirm',
//         color: 'danger',
//         title: 'Are you sure?',
//         text: 'You will not be able to recover this User!',
//         accept: this.Delete,
//         acceptText: 'Delete'
//       })
//     },
//     Delete () {
//       this.$store.dispatch("vendor/Delete", this.params.data.user_id)
//       .then(() => {
//         this.params.data.refreshData()
//         this.ShowSuccessMessage({
//           title: 'Vendor Deleted',
//           text: 'The selected Vendor was successfully deleted'
//         })
//       })
//       .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
//     },

//     // Notify
//     ShowSuccessMessage ({ title, text }) {
//       this.$vs.notify({
//         iconPack: 'feather',
//         icon: 'icon-check',
//         color: 'success',
//         title,
//         text
//       })
//     },
//     ShowErrorMessage ({ title, text }) {
//       this.$vs.notify({
//         iconPack: 'feather',
//         icon: 'icon-alert-circle',
//         color: 'danger',
//         title,
//         text
//       })
//     }
//   }
}
</script>
